export default __webpack_public_path__ + "static/media/ethiopia.fdb0c657.svg";